import * as css from './LectureTile.css';
import {TTimetableSalesLecture} from '../../../../../../../redux/realtime/realtime.type';
import {teamMemberPhoto} from '../../../../../../../assets/symbols/images/teamMemberPhoto';

const MAX_AVATARS = 3;

function TileLecturers({lecturers, active}: {lecturers: TTimetableSalesLecture['lecturers']; active: boolean}) {
    if(!lecturers.length) return null;

    if(lecturers.length === 1) {
        const [only] = lecturers;
        return (
            <css.assignee $active={active} data-cy="lectureTile-lecturers">
                <span>{only.name}</span>
                <css.avatar $image={only.image || teamMemberPhoto} />
            </css.assignee>
        );
    }

    const visible = lecturers.slice(0, MAX_AVATARS);
    const overflow = lecturers.length - visible.length;
    return (
        <css.avatarsStack $active={active} data-cy="lectureTile-lecturers">
            {visible.map(l => <css.avatar key={l.lid} $image={l.image || teamMemberPhoto} />)}
            {overflow > 0 && <css.overflowBadge>+{overflow}</css.overflowBadge>}
        </css.avatarsStack>
    );
}

export default TileLecturers;
